import { Loader } from 'semantic-ui-react';
export default Loader;